var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/AwardsCommonWinnersList/AwardsCommonWinnersList.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/AwardsCommonWinnersList/AwardsCommonWinnersList.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
var macro_t_4 = runtime.makeMacro(
[], 
["data", "winners"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});frame.set("winners", Object.prototype.hasOwnProperty.call(kwargs, "winners") ? kwargs["winners"] : runtime.contextOrFrameLookup(context, frame, "False"));var t_5 = "";t_5 += "\n<div class=\"AwardsCommonWinnersList-nominees\">\n    ";
frame = frame.push();
var t_8 = runtime.contextOrFrameLookup(context, frame, "data");
if(t_8) {t_8 = runtime.fromIterator(t_8);
var t_7 = t_8.length;
for(var t_6=0; t_6 < t_8.length; t_6++) {
var t_9 = t_8[t_6];
frame.set("nominee", t_9);
frame.set("loop.index", t_6 + 1);
frame.set("loop.index0", t_6);
frame.set("loop.revindex", t_7 - t_6);
frame.set("loop.revindex0", t_7 - t_6 - 1);
frame.set("loop.first", t_6 === 0);
frame.set("loop.last", t_6 === t_7 - 1);
frame.set("loop.length", t_7);
t_5 += "\n        <div class=\"AwardsCommonWinnersList-nominee ";
if(runtime.memberLookup((t_9),"winner")) {
t_5 += " AwardsCommonWinnersList-nominee--winner";
;
}
t_5 += " ";
if(runtime.contextOrFrameLookup(context, frame, "winners")) {
t_5 += " AwardsCommonWinnersList-nominee--winner-each";
;
}
t_5 += "\">\n            <div class=\"AwardsCommonWinnersList-nomineeTitle\">";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"caption"), env.opts.autoescape);
t_5 += "</div>\n            ";
if(runtime.memberLookup((t_9),"category")) {
t_5 += "<div class=\"AwardsCommonWinnersList-nomineeNomination\">";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"category"), env.opts.autoescape);
t_5 += "</div>\n            ";
;
}
t_5 += "<div class=\"AwardsCommonWinnersList-nomineePersons\">\n                ";
frame = frame.push();
var t_12 = runtime.memberLookup((t_9),"members");
if(t_12) {t_12 = runtime.fromIterator(t_12);
var t_11 = t_12.length;
for(var t_10=0; t_10 < t_12.length; t_10++) {
var t_13 = t_12[t_10];
frame.set("member", t_13);
frame.set("loop.index", t_10 + 1);
frame.set("loop.index0", t_10);
frame.set("loop.revindex", t_11 - t_10);
frame.set("loop.revindex0", t_11 - t_10 - 1);
frame.set("loop.first", t_10 === 0);
frame.set("loop.last", t_10 === t_11 - 1);
frame.set("loop.length", t_11);
t_5 += "\n                    <div class=\"AwardsCommonWinnersList-nomineePerson\">\n                        <div class=\"AwardsCommonWinnersList-nomineePersonPosition\">";
t_5 += runtime.suppressValue(runtime.memberLookup((t_13),"title"), env.opts.autoescape);
t_5 += "</div>\n                        <div class=\"AwardsCommonWinnersList-nomineePersonName\">";
if(runtime.memberLookup((t_13),"url")) {
t_5 += "<a href=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((t_13),"url"), env.opts.autoescape);
t_5 += "\">";
;
}
t_5 += runtime.suppressValue(runtime.memberLookup((t_13),"name"), env.opts.autoescape);
if((runtime.memberLookup((t_13),"url"))) {
t_5 += "</a>";
;
}
t_5 += "</div>\n                    </div>\n                ";
;
}
}
frame = frame.pop();
t_5 += "\n            </div>\n        </div>\n    ";
;
}
}
frame = frame.pop();
t_5 += "\n</div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_5);
});
context.addExport("AwardsCommonWinnersList");
context.setVariable("AwardsCommonWinnersList", macro_t_4);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/AwardsCommonWinnersList/AwardsCommonWinnersList.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/AwardsCommonWinnersList/AwardsCommonWinnersList.jinja
// module id = 41
// module chunks = 0